//@ts-ignore
import $i18n from '@/i18n';
import React from 'react';
import DarkToolTip from '@/components/DarkToolTip';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

const iconCellRender = (v, i, record) => v === 'CONTROLLED' ? <CheckCircleOutlined style={{ fontSize: 14, color: '#29A64E' }} /> : <CloseCircleOutlined style={{ fontSize: 14, color: "#D4D6DB" }} />

const tipRenderCell = (v, i, record) => <DarkToolTip lineCount={1} placement="topLeft" arrow={{ pointAtCenter: true }} triggerContent={v} content={v} />
export const tableColumons = [
  // {
  //   title: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.sn", dm: 'SN' }),
  //   dataIndex: 'id',
  //   width: 40,
  // },
  {
    title: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.jsapiName", dm: '名称' }),
    dataIndex: 'jsapiName',
    width: 140,
    cell: tipRenderCell,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.functionDesc', dm: '描述' }),
    dataIndex: 'functionDesc',
    cell: tipRenderCell,
    // filters: roleFilters,
    // filterMode: 'single',
    width: 300,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.channelName', dm: '渠道' }),
    dataIndex: 'channelName',
    cell: tipRenderCell,
    width: 120,
    // filters: statusFilters,
    // filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.supportSystem', dm: '支持的系统' }),
    dataIndex: 'supportSystem',
    width: 140,
    cell: (v) => v?.join(' / '),
  }
];